require("./bootstrap");

import pageHandler from "./pageHandler";
pageHandler();
